import { Col, Form, Input, Row } from 'ui';

export type JoinedOrganizationsListFiltersFormValues = {
  search?: string;
};
const JoinedOrganizationsListFilters = () => (
  <Row>
    <Col span={24}>
      <Form.Item<JoinedOrganizationsListFiltersFormValues> label="Search" name="search">
        <Input hasSearch />
      </Form.Item>
    </Col>
  </Row>
);

export default JoinedOrganizationsListFilters;
